"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("firebase/app");
const config = {
    apiKey: process.env["REACT_APP_FIRE_BASE_KEY"],
    authDomain: process.env["REACT_APP_FIRE_BASE_AUTH_DOMAIN"],
    databaseURL: process.env["REACT_APP_FIRE_BASE_DB_URL"],
    projectId: process.env["REACT_APP_FIRE_BASE_PROJECT_ID"],
    storageBucket: process.env["REACT_APP_FIRE_BASE_STORAGE_BUCKET"],
    messagingSenderId: process.env["REACT_APP_FIRE_BASE_MESSAGING_SENDER_ID"],
    appId: process.env["REACT_APP_FIRE_BASE_APP_ID"],
    measurementId: process.env["REACT_APP_FIRE_BASE_MEASURMENT_ID"],
};
const firebaseApp = (0, app_1.initializeApp)(config);
exports.default = firebaseApp;
